import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Input, Button, Space, Select, message } from 'antd'
import { validateEmail, validatePhone } from '../../assets/js/validators'
import { apiCheckAccount, apiGetPage } from '../../request/api'
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface LoadAccountProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

const LoadAccount: React.FC<LoadAccountProps> = ({ handleViewChange, data }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [activeIndex, setActiveIndex] = useState(0);
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')    
    const [identifyingString, setIdentifyingString] = useState<string | null | undefined>('发送验证码');
    const [error, setError] = useState<string | null | undefined>(null);
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: ''
    });
    const { getValue, customData } = useCustomData();

    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // 移除实时验证，仅更新状态
        if (activeIndex === 0) {
            setEmail(value);
        } else if (activeIndex === 1) {
            setPhone(value);
        }
        setError(null); // 输入时清除错误
    };
    useEffect(() => {
        if (data) {
            setActiveIndex(0)
        } else {
            setActiveIndex(data)
        }
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setIdentifyingString(getValue('sendIdentifying'))
        setLoginInfo(newLoginInfo);
    }, [customData]);

    const toNext = () => {
        // 新增验证逻辑
        let isValid = true;
        if (activeIndex === 0) {
            if (!validateEmail(email)) {
                setError(loginInfo.emailError);
                isValid = false;
            }
        } else if (activeIndex === 1) {
            if (!validatePhone(phone)) {
                setError(loginInfo.phoneError);
                isValid = false;
            }
        }

        if (!isValid) return;

        // 保持原有的API调用逻辑不变
        const account = activeIndex === 0 ? email : phone;
        apiCheckAccount({
            accountName: account
        }).then(res => {
            if (res.data.data) {
                messageApi.open({
                    type: 'success',
                    content: '账号校验成功',
                });
                setTimeout(() => {
                    handleViewChange('credentialsVerification', account)
                }, 2000)
            } else {
                messageApi.open({
                    type: 'error',
                    content: '账号校验失败',
                });
            }
        });
    };

    const switchTab = [
        {
            'switchname': loginInfo.email
        },
        {
            'switchname': loginInfo.phone
        }
    ]
    const options = [
        {
            value: '+86',
            label: '+86',
        },
        {
            value: '+72',
            label: '+72',
        },
    ];
    const isAnyFieldFilled = phone !== '' || email !== '';

    return (
        <div>
            {contextHolder}
            <div className='login-header'>{loginInfo.getBack}</div>
            <div className='login-text'>
                {switchTab.map((item, index) => (
                    <span key={index} className='login-switch'
                        onClick={() => {
                            setActiveIndex(index);
                            setError(null);
                            setEmail('');
                            setPhone('');
                        }}
                        style={{
                            color: index === activeIndex ? themeColor : 'inherit',
                            cursor: 'pointer'
                        }}>{item.switchname}</span>
                ))}
            </div>

            <div>
                {activeIndex === 0 && <Input placeholder={loginInfo.enterEmail} status={error ? 'error' : ''} value={email} onChange={inputChange}></Input>}
                {activeIndex === 1 && <Space.Compact>
                    <Select defaultValue="+86" options={options} />
                    <Input className='phoneInput' status={error ? 'error' : ''} value={phone} placeholder={loginInfo.enterPhone} onChange={inputChange} />
                </Space.Compact>}
                {error && (
                    <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                        {error}
                    </div>
                )}
            </div>
            <Button
                type="primary"
                onClick={toNext}
                disabled={!isAnyFieldFilled} // 移除error相关禁用条件
            >
                {loginInfo.next}
            </Button>
            <div className='or-div'>
                <div className='line'></div>
                <div className='line-text'>{loginInfo.orInfo}</div>
                <div className='line'></div>
            </div>
            {/* <Button onClick={toNext} disabled={!isAnyFieldFilled || error !== null}>{loginInfo.next}</Button> */}
            <button className='line-button' onClick={() => handleViewChange("mainLogin")} style={{ color: themeColor }}>{loginInfo.backLogin}</button>
        </div>
    )

};

export default LoadAccount;
